import { render } from "./board.vue?vue&type=template&id=683bb933"
import script from "./board.vue?vue&type=script&lang=js"
export * from "./board.vue?vue&type=script&lang=js"

import "./board.vue?vue&type=style&index=0&id=683bb933&lang=scss"

import exportComponent from "/Users/a/Documents/work/new/prnew/lk-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__